const { useSnackbar } = require("notistack");

// the api reports failures in two shapes: validation errors as
// { errors: { field: [msg] } }, and everything else as { message: "..." }.
// reading .errors unconditionally threw on the second shape, which swallowed
// every non-validation error and left the user with a bare error screen.
export const toErrorMessages = (err) => {
  if (typeof err === "string") return [err];

  const { errors, message } = err ?? {};

  if (errors && typeof errors === "object") {
    const messages = Object.values(errors).flat().filter(Boolean);
    if (messages.length > 0) return messages;
  }

  if (message) return [message];

  return ["Something went wrong"];
};

const useErrors = () => {
  const { enqueueSnackbar } = useSnackbar();

  return (err) =>
    toErrorMessages(err).map((item) =>
      enqueueSnackbar(item, { variant: "error" })
    );
};

export default useErrors;
